function CalculatePercent(amount,percent) {
     
    return amount*percent/100;
}

module.exports = CalculatePercent;